import type { Conversation } from "@twilio/conversations";
import { makeMockConversation } from "./mockConversation";

const MOCK_DB: Record<string, Conversation> = {};

export async function mockGetConversationBySid(
  sid: string
): Promise<Conversation> {
  await new Promise((r) => setTimeout(r, 250));

  if (sid === "CH_FORBIDDEN") {
    const err: any = new Error("Forbidden");
    err.status = 403;
    throw err;
  }

  if (!MOCK_DB[sid]) {
    MOCK_DB[sid] = makeMockConversation({
      sid,
      friendlyName: `Conversazione mock (${sid.slice(-6)})`,
      lastReadMessageIndex: 12,
      lastMessage: { index: 99, dateCreated: new Date(Date.now() - 60_000) },
    });
  }

  return MOCK_DB[sid];
}
